import unity from "../images/unity.svg";
import "../styles/customTheme.css";

import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import { Layout, Space } from "antd";
import { GithubFilled, MailOutlined } from "@ant-design/icons";
import LinkNewTab from "./LinkNewTab";
import Menu, { MenuItem } from "./menu";

const { Header, Footer, Content } = Layout;

const Container = ({ defKey, children }) => {
  return (
    <Layout style={{ backgroundColor: "transparent" }}>
      <Menu selectedKey={defKey}>
        <MenuItem pageKey="1" link="/assets/">
          Unity Assets
        </MenuItem>
        {/* <Menu.Item pageKey="2" link="/projects/">
              Other Projects
            </Menu.Item> */}
        <MenuItem pageKey="3" link="/mods/">
          Mods
        </MenuItem>
        {/* <Menu.Item pageKey="4" link="/contact/">
              Support / Contact
            </Menu.Item> */}
      </Menu>
      <Content
        style={{
          padding: "24px 24px",
          marginTop: 64,
          background: "transparent",
          minHeight: "100vh", //edit this to change minimum page height
        }}
      >
        <div style={{ maxWidth: "900px", margin: "0 auto" }}>{children}</div>
      </Content>
      <Footer
        style={{
          backgroundColor: "#101010",
          color: "#FFFFFF",
          fontSize: "16px",
        }}
      >
        <span
          style={{
            float: "left",
          }}
        >
          © {new Date().getFullYear()} Criz Games
        </span>
        <span style={{ float: "right" }}>
          <Space size="middle">
            <LinkNewTab to="mailto:comp.criz.games@gmail.com">
              <MailOutlined className="icon white" />
            </LinkNewTab>
            <LinkNewTab to="https://assetstore.unity.com/publishers/51178">
              <img
                src={unity}
                style={{
                  color: "white",
                  height: "24px",
                  transform: "translateY(2px)",
                }}
              />
            </LinkNewTab>
            <LinkNewTab to="https://github.com/CrizGames/">
              <GithubFilled className="icon white" />
            </LinkNewTab>
          </Space>
        </span>
      </Footer>
    </Layout>
  );
};
Container.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Container;
